import { useEffect, useState } from "react";
import { CustomDataGrid } from "../../../common/components/Table/CustomDataGrid";
import { sampleReceiverGridColumns } from "../utilis/sampleReceiverGridColumns";
import { edit_sample_receiver_schedule, load_sample_receiver_data_from_backend } from "../utilis/sampleReceiverServices";

const TabContent = ({ tabName, hiddenColumns }) => {
    const [data, setData] = useState([]);
    const columnsData = Object.values(sampleReceiverGridColumns);
    useEffect(() => {
        load_sample_receiver_data_from_backend(data, setData, tabName);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tabName]);
    return (
        <>
            {
                data && <CustomDataGrid
                    processRowUpdate={async (updatedRow, originalRow) => {
                        console.log("updating row");
                        const result = await edit_sample_receiver_schedule(updatedRow, tabName);
                        if (result) return updatedRow;
                        else return originalRow;
                    }
                    }
                    columns={columnsData}
                    rows={data || []}
                    initialState={{
                        columns: {
                            columnVisibilityModel: hiddenColumns,
                        },
                        pinnedColumns: {
                            right: [
                                "storage_condition",
                                "receiving_date_by_qc"
                            ]
                        }
                    }}
                    sx={{
                        height: "700px"
                    }}
                />
            }


        </>
    );
};
export default TabContent;